// extracted by mini-css-extract-plugin
module.exports = {"milestonesWrap":"Milestones_milestonesWrap__37DTZ","title":"Milestones_title__38i8X","milestones":"Milestones_milestones__2Zv9h","milestone":"Milestones_milestone__2uLra"};